import { render, staticRenderFns } from "./ShopRecordTable.vue?vue&type=template&id=0b8a0416&scoped=true&"
import script from "./ShopRecordTable.vue?vue&type=script&lang=js&"
export * from "./ShopRecordTable.vue?vue&type=script&lang=js&"
import style0 from "./ShopRecordTable.vue?vue&type=style&index=0&id=0b8a0416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a0416",
  null
  
)

export default component.exports